import React, { useState } from "react";
import styled from "@emotion/styled";
import {
  PriceInput,
  ProductDescription,
} from "@pages/register/_components/index";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import useRegisterStepStore from "@store/register/useRegisterStepStore";
import ProductPhotos from "@pages/register/_components/ProductPhotos";
import { useTranslation } from "react-i18next";
import BasicModal from "@components/modal/BasicModal";
import { ModalContent } from "@components/modal/ModalContent";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
  paddingBottom: "2rem ",
});

const Title = styled.h3(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "2rem",
  lineHeight: "2.8rem",
  fontWeight: theme.fontWeight.bold,
}));

const RegisterProductStepThree = () => {
  const { watch, setValue } = useFormContext();
  const { t } = useTranslation();
  const { increaseStep } = useRegisterStepStore();
  const price = watch("price");
  const imageList = watch("image_list");
  const description = watch("description_ko");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const valid = () => {
    if (price < 1000) {
      setIsModalOpen(true);
    }
    // 첫 번째 이미지를 썸네일로 설정
    else if (imageList.length > 0) {
      setValue("thumbnail_url", imageList[0]);
      increaseStep();
    }
  };

  const isValid =
    price > 0 && imageList.length > 0 && description.trim() !== "";

  return (
    <Container>
      <Title>
        <span>{t("등록하려는 상품의")}</span>
        <span>{t("상세정보를 알려주세요.")}</span>
      </Title>

      <PriceInput />

      <ProductDescription />

      <ProductPhotos />

      <BasicButton
        title="다음"
        height="5.2rem"
        width="100%"
        padding="1.6rem 1.2rem"
        disabled={!isValid}
        onClick={valid}
      />

      <BasicModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        activeEvent={() => {
          setIsModalOpen(false);
        }}
        activeName="확인"
        padding="2rem">
        <ModalContent
          mainMessage={"상품 금액은"}
          subMessage={"최소 1,000원 이상이어야합니다."}
        />
      </BasicModal>
    </Container>
  );
};

export default RegisterProductStepThree;
